import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SidebarProvider } from './context/SidebarContext';
import { AuthProvider } from './context/AuthContext';

// Auth pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import PendingApproval from './pages/auth/PendingApproval';

// Layout
import AppLayout from './components/layout/AppLayout';

// Admin pages
import AdminDashboard from './pages/admin/AdminDashboard';
import AlumniInformation from './pages/admin/AlumniInformation';
import EventPage from './pages/admin/EventPage';
import JobPost from './pages/admin/JobPost';
import AccountSetting from './pages/admin/AccountSetting';
import FeedbackResponse from './pages/admin/Feedback';

// Alumni pages
import AlumniDashboard from './pages/alumni/AlumniDashboard';
import AlumniProfile from './pages/alumni/AlumniProfile';
import Jobs from './pages/alumni/Jobs';
import Events from './pages/alumni/Events';
import AlumniFeedback from './pages/alumni/AlumniFeedback';

// Not found 404 page
import NotFound from './pages/NotFound';

// Terms and Conditions
import TermsPage from './pages/TermsPage';

// Forgot Password
import ForgotPassword from './pages/auth/ForgotPassword';

import ProtectedRoute from './components/routes/ProtectedRoute';

function App() {
  return (
    <Router>
      <AuthProvider>
        <SidebarProvider>
          <Routes>
            {/* Auth routes without sidebar */}
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pendingapproval" element={<PendingApproval />} />

            {/* Admin routes */}
            <Route
              path="/AdminDashboard"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <AdminDashboard />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/AlumniInformation"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <AlumniInformation />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/EventPage"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <EventPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/JobPost"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <JobPost />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/AccountSetting"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <AccountSetting />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/feedBack"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <FeedbackResponse />
                  </AppLayout>
                </ProtectedRoute>
              }
            />

            {/* Alumni routes */}
            <Route
              path="/AlumniDashboard"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <AlumniDashboard />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/AlumniProfile"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <AlumniProfile />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/Jobs"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Jobs />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/Events"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Events />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/AlumniFeedback"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <AlumniFeedback />
                  </AppLayout>
                </ProtectedRoute>
              }
            />

            {/* 404 route (must be last) */}
            <Route path="*" element={<NotFound />} />

            {/* Terms and Conditions */}
            <Route path="/terms" element={<TermsPage />} />

            {/* Forgot Password */}
            <Route path="/forgotpassword" element={<ForgotPassword />} />
          </Routes>
        </SidebarProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
